import React from 'react';
import styles from './Redirecting.module.scss';
import Loader from 'components/Loader/Loader';

const Redirecting = () => {
  return (
    <div className={styles.redirectingContainer}>
      <div className={styles.content}>
        <p>Redirecting you...</p>
        <Loader loading />
      </div>
    </div>
  );
};

export default Redirecting;
